import { getTranslations, hasAnyTranslation } from '@assets/i18n/config';
import type { TranslatedString } from '@interfaces/shared';

const KNOWN_ACRONYMS = new Set([
  'CESG',
  'CRA',
  'EFT',
  'FATCA',
  'FHSA',
  'ID',
  'IIROC',
  'PEP',
  'RDSP',
  'RESP',
  'RRSP',
  'SIN',
  'TFSA',
]);

function splitCamelCase(key: string): string[] {
  if (!key) return [];

  return key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .split(/\s+/)
    .filter(Boolean);
}

function formatWord(word: string): string {
  const upper = word.toUpperCase();
  if (KNOWN_ACRONYMS.has(upper)) {
    return upper;
  }

  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/** Converts camelCase field keys to Title Case with smart acronym handling. */
export function camelCaseToTitleCase(key: string): string {
  const words = splitCamelCase(key);
  const parts: string[] = [];

  for (let index = 0; index < words.length; index += 1) {
    const word = words[index];
    const nextWord = words[index + 1];

    if (
      word.toLowerCase() === 'i' &&
      nextWord !== undefined &&
      nextWord.toUpperCase() === 'D'
    ) {
      parts.push('ID');
      index += 1;
      continue;
    }

    parts.push(formatWord(word));
  }

  return parts.join(' ');
}

/**
 * Returns the translated label for a field key from workflowReviewFields.json,
 * or null if no translation exists for that key.
 * The JSON file is the single source of truth for which fields have known labels.
 */
export function getKnownFieldLabel(key: string): TranslatedString | null {
  const translation = getTranslations({
    fileName: 'workflowReviewFields',
    translationPath: [key],
  });
  return hasAnyTranslation(translation)
    ? (translation as TranslatedString)
    : null;
}
